import * as VideoActions from '../actions/videoActions';
import { unlink } from 'fs';

const defaultState = {
    videoGallery: [],
    videoDescription: {},
    video: {},
    uploadProgress: 0,
    chapterPart: {},
    discussion: [],
    flags: [],
    logs: [],
    currentLog: null,
    videoQuestions: [],
    chapterPartTestResults: {},
    scoringTest: false,
    testScored: false,
    showNextVideo: false,
    loading: false,
    sc: [],
    userSubject: {},
    userLecture: null,
    testCourse: {},
    userLectureTests: [],
    courseUser: [{
        role: 'demo',
        completedChapterParts: [],
        completedChapters: [],
        completedSubjects: [],
        currentSubject: '',
        currentChapter: '',
        currentChapterPart: '',
        Course: {
            CourseSubject: []
        }
        
    }],
    allCourseUsers: [],
    course: null,
    us: [],
    ul: [],
    testDetails: {},
    quizDetails: {},
    canView: false,
    notifications: [],
    syllabus: {},
    checkForMoreNotifications: true,
    quiz: {}
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case 'GOT_UL_QUIZ_QUESTION':
            return {
                ...state,
                quiz: {
                    ...state.quiz,
                    ...action.payload
                }
            }
        case 'GOT_UL_QUIZ':
            return {
                ...state,
                quiz: action.payload
            }
        case 'VIDEO_LECTURE_RETRIEVED':
            return {
                ...state,
                
                userSubject: action.payload.userSubject.id === state.userSubject.id ? 
                {
                    ...state.userSubject,
                    ...action.payload.userSubject,
                    Subject: state.userSubject.Subject
                }
                :
                {
                    ...action.payload.userSubject,
                    Subject: {
                        ...action.payload.userSubject.Subject,
                        CourseChapter: action.payload.userSubject.Subject.CourseChapter.map(chap => {
                            if(state.userSubject.Subject){
                                if(state.userSubject.Subject.CourseChapter.filter(ch => ch.id === chap.id).length > 0){
                                    return {
                                        ...state.userSubject.Subject.CourseChapter.filter(ch => ch.id === chap.id)[0],
                                        ...chap,
                                        loading: true
                                    }
                                }else{
                                    return {
                                        ...chap,
                                        loading: true,
                                        ChapterVideo: []
                                    }
                                }
                            }else{
                                return {
                                    ...chap,
                                    loading: true,
                                    ChapterVideo: []
                                }
                            }
                               
                        })
                    }
                },
                courseUser: state.courseUser.length > 0 ? state.courseUser.map(cu => {
                    if(!cu || !cu.id) {
                        return action.payload.cu
                    }else if(cu.id === action.payload.cu.id){
                        return {
                            ...cu,
                            ...action.payload.cu
                        }
                    }else{
                        return cu
                    }
                }) : state.courseUser.concat(action.payload.cu),
                userLecture: state.userLecture ? state.userLecture.id === action.payload.userLecture.id ? {
                    ...state.userLecture,
                    ...action.payload.userLecture
                } : action.payload.userLecture : action.payload.userLecture,
                chapterPart: {
                    ...action.payload.userLecture.Lecture,
                    VideoQuestions: action.payload.userLecture.Lecture ? action.payload.userLecture.Lecture.VideoQuestions.filter(q => (q.audioUrl !== null && q.answer !== "") || (q.correctOption !== "" && q.optionA !== "")) : []
                },
                discussion: action.payload.userLecture.Lecture ? action.payload.userLecture.Lecture.VideoDiscussion : [],
                loading: false,
                scoringTest: false,
                testScored: action.payload.userLecture.Quiz ? (action.payload.userLecture.Quiz.length > 0) : false,
                videoQuestions: action.payload.userLecture.VideoQuestions,
                quiz: action.payload.userLecture.Quiz ? action.payload.userLecture.Quiz.length > 0 ? action.payload.userLecture.Quiz[0] : {} : {},
                chapterPartTestResults: action.payload.userLecture.Quiz ? action.payload.userLecture.Quiz.length > 0 ? action.payload.userLecture.Quiz[0].completed ? action.payload.userLecture.Quiz[0] : {} : {} : {},
                canView: true
            }
        case VideoActions.LOADED_SLIM_COURSE:
            return {
                ...state,
                sc: action.payload
            };
        case 'CANVIEW_FALSE': 
            return {
                ...state,
                canView: false
            }
        case 'TEST_DETAILS':
            return {
                ...state,
                testDetails: action.payload
            }
        case 'QUIZ_DETAILS':
            return {
                ...state,
                quizDetails: action.payload
            }
        case 'GOT_SYLLABUS':
            return {
                ...state,
                syllabus: {
                    ...action.payload,
                    lastUpdated: new Date()
                }
            }
        case 'GOT_NOTIFICATIONS':
            return {
                ...state,
                notifications: action.payload
            }
        case 'CHECK_NOTIFICATIONS':
            return {
                ...state,
                checkForMoreNotifications: action.payload
            }
        case 'EXPAND_NOTIFICATIONS':
            return {
                ...state,
                notifications: state.notifications.concat(action.payload)
            }
        case 'GOT_USER_LECTURE_TESTS':
            return {
                ...state,
                userLectureTests: action.payload
            }
        case 'CANVIEW_NO':
            return {
                ...state,
                canView: 'no'
            }
        case VideoActions.ADD_SLIM_LECTURE:
            return {
                ...state,
                sc: state.sc.concat({id: action.payload.id, title: action.payload.title})
            }
            break;
        case 'GOT_TEST_COURSE':
            return {
                ...state,
                testCourse: action.payload
            }
        case 'REMOVED_QUIZ':
            return {
                ...state,
                chapterPartTestResults: {}
            }
            break;
        case 'GOT_COMPLETED_SUBJECTS':
            return {
                ...state,
                us: action.payload
            }
        case 'GOT_COMPLETED_USER_LECTURES':
            return {
                ...state,
                ul: action.payload
            }
        case 'GOT_COURSE_AND_SUBJECTS':
            return {
                ...state,
                course: action.payload
            };
        case 'UPDATE_SLIM_ITEM':
            return {
                ...state,
                sc: state.sc.map(s => {
                    if(s.id === action.payload.id){
                        return {
                            id: action.payload.id,
                            title: action.payload.title
                        }
                    }else{
                        return s
                    }
                })
            }
        case 'GOT_FLAGS':
            return {
                ...state,
                flags: action.payload
            }
        case 'GOT_LOGS':
            return {
                ...state,
                logs: action.payload
            }
        case 'ADDED_LOG':
            return {
                ...state,
                logs: state.logs.concat(action.payload),
                currentLog: action.payload
            }
        case 'UPDATED_LOG':
            return {
                ...state,
                logs: state.logs.map(l => {
                    if(l.id === action.payload.id){
                        return {
                            ...l,
                            ...action.payload
                        }
                    }else{
                        return l
                    }
                }),
                currentLog: action.payload
            }
        case 'UPDATE_LOADING':
            return {
                ...state,
                loading: true
            }
        case VideoActions.ACTION_VIDEO_INITIALIZE:
            return {
                ...state,
                video: {
                    ...state.video,
                    video: action.payload[0] || []
                },
                scoringTest: false,
                testScored: false
            };
        case VideoActions.FLAG_ADDED:
            return {
                ...state,
                flags: state.flags.concat(action.payload.flag)
            };
        case VideoActions.UPDATED_COURSE_USER:
            return {
                ...state,
                courseUser: state.courseUser.map(cu => {
                    if(cu.id === action.payload.id){
                        return {
                            ...cu,
                            ...action.payload,
                            UserLecture: cu.UserLecture
                        }
                    }else{
                        return cu
                    }
                })
            }
            break;
        case VideoActions.ACTION_EDITED_CU:
            return {
                ...state,
                courseUser: state.courseUser.map(c => {
                    if(c.id === action.payload.id){
                        return {
                            ...c,
                            ...action.payload
                        }
                    }else{
                        return c
                    }
                })
            }
            break;
        case VideoActions.COURSE_STATUS_UPDATED:
            return {
                ...state,
                courseUser: state.courseUser.map((cu, i) => {
                    if(cu.id === action.payload.courseUserId){
                        return {
                            ...cu,
                            courseStatus: action.payload.courseStatus
                        }
                    }else{
                        return cu
                    }
                })
            };
        case VideoActions.ACTION_USER_QUESTIONS_RESET:
            return {
                ...state,
                videoQuestions: state.videoQuestions.map(q => {
                    return {
                        ...q,
                        complete: false
                    }
                }),
                scoringTest: false,
                testScored: false
            };
        case VideoActions.RESET_CHAPTER_TESTS:
            return {
                ...state,
                chapterPartTestResults: {}
            };
        case VideoActions.ACTION_GOT_DISCUSSION:
            return {
                ...state,
                discussion: action.payload
            };
        case VideoActions.ACTION_DELETED_DISCUSSION:
            return {
                ...state,
                discussion: state.discussion.filter(d => d.id !== action.payload)
            };
        case VideoActions.ACTION_DELETED_COMMENT:
            return {
                ...state,
                discussion: state.discussion.map(d => {
                    return {
                        ...d,
                        DiscussionComment: d.DiscussionComment.filter(c => c.id !== action.payload)
                    }
                })
            };
        case VideoActions.ACTION_USER_SUBJECT_RETRIEVED:
            return {
                ...state,
                userSubject: {
                    ...action.payload,
                    Subject: {
                        ...action.payload.Subject,
                        CourseChapter: action.payload.Subject ? action.payload.Subject.CourseChapter.map(chap => {
                            if(state.userSubject.Subject){
                                if(state.userSubject.Subject.CourseChapter.filter(ch => ch.id === chap.id).length > 0){
                                    return {
                                        ...state.userSubject.Subject.CourseChapter.filter(ch => ch.id === chap.id)[0],
                                        ...chap,
                                        loading: true
                                    }
                                }else{
                                    return {
                                        ...chap,
                                        loading: true,
                                        ChapterVideo: []
                                    }
                                }
                            }else{
                                return {
                                    ...chap,
                                    loading: true,
                                    ChapterVideo: []
                                }
                            }
                               
                        }) : []
                    }
                }
            };
        case 'GOT_USER_SUBJECT_CHAPTERS':
            return {
                ...state,
                userSubject: {
                    ...state.userSubject,
                    Subject: {
                        ...state.userSubject.Subject,
                        CourseChapter: state.userSubject.Subject.CourseChapter.map(chap => {
                            if(chap.id === action.payload.id){
                                return {
                                    ...chap,
                                    loading: false,
                                    ...action.payload
                                }
                            }else{
                                return chap
                            }
                            
                        })
                    }
                }
            };
        case VideoActions.VIDEO_TIME_SYNC:
            return {
                ...state,
                courseUser: state.courseUser.map(cu => {
                    if(cu.id === action.payload.id){
                        return {
                            ...cu,
                            currentUserTime: action.payload.currentUserTime,
                            currentPartVideoTime: action.payload.currentPartVideoTime,
                            currentVideoTime: action.payload.currentVideoTime
                        }
                    }else{
                        return {
                            ...cu
                        }
                    }
                })
            };
        case 'GOT_SINGLE_COURSE_USER':
            return {
                ...state,
                courseUser: [action.payload]
            }
        case VideoActions.ACTION_COURSE_USER_RETRIEVED:
            
            return {
                ...state,
                allCourseUsers: action.payload || []
            };
        case VideoActions.DELETED_VIDEO:
            return {
                ...state,
                video: {}
            };
        case VideoActions.ACTION_TEST_RETRIEVED:
            return {
                ...state,
                chapterPartTestResults: action.payload === null ? {} : action.payload.length > 0 ? action.payload[action.payload.length - 1] : action.payload,
                testScored: true
            };
        case VideoActions.ACTION_TEST_SCORED:
            return {
                ...state,
                scoringTest: false,
                quiz: {
                    ...state.quiz,
                    ...action.payload
                },
                chapterPartTestResults: action.payload,
                testScored: true
            };
        case VideoActions.ACTION_SUBMIT_TEST:
            return {
                ...state,
                scoringTest: true,
                testScored: false
            };
        case VideoActions.ACTION_USER_QUESTION_RETRIEVED:
            return {
                ...state,
                videoQuestions: action.payload
            };
        case 'REMOVED_USERLECTURE':
            return {
                ...state,
                ul: state.ul.filter(l => l.id !== action.payload)
            }
            break;
        case 'ADDED_USERLECTURE':
            return {
                ...state,
                ul: state.ul.concat(action.payload) || []
            }
            break;
        case 'USER_LECTURE_UPDATED': 
            return {
                ...state,
                loading: false,
                userLecture: state.userLecture ? state.userLecture.id === action.payload.id ? {
                    ...state.userLecture,
                    ...action.payload
                } : state.userLecture : state.userLecture,
                ul: state.ul.map(u => {
                    if(u.id === action.payload.id){
                        return {
                            ...u,
                            ...action.payload
                        }
                    }else{
                        return u
                    }
                }),
                courseUser: state.courseUser.map(cu => {
                    return {
                        ...cu,
                        UserLecture: cu.UserLecture ? cu.UserLecture.filter(ul => ul.id === action.payload.id).length === 0 ? cu.UserLecture.concat(action.payload) : cu.UserLecture.map(ul => {
                            if(ul.id === action.payload.id){
                                return {
                                    ...ul,
                                    ...action.payload
                                }
                            }else{
                                return ul
                            }
                        }) : []
                    }
                })
            }

        case 'DIAG_USER_LECTURE_RETRIEVED':
            return {
                ...state,
                userLecture: action.payload
            }
        
        case 'USER_LECTURE_RETRIEVED':
            return {
                ...state,
                userLecture: state.userLecture ? state.userLecture.id === action.payload.id ? {
                    ...state.userLecture,
                    ...action.payload
                } : action.payload : action.payload,
                chapterPart: {
                    ...action.payload.Lecture,
                    VideoQuestions: action.payload.Lecture ? action.payload.Lecture.VideoQuestions.filter(q => (q.audioUrl !== null && q.answer !== "") || (q.correctOption !== "" && q.optionA !== "")) : []
                },
                discussion: action.payload.Lecture ? action.payload.Lecture.VideoDiscussion : [],
                loading: false,
                scoringTest: false,
                testScored: action.payload.Quiz ? (action.payload.Quiz.length > 0) : false,
                videoQuestions: action.payload.VideoQuestions,
                quiz: action.payload.Quiz ? action.payload.Quiz.length > 0 ? action.payload.Quiz[0] : {} : {},
                chapterPartTestResults: action.payload.Quiz ? action.payload.Quiz.length > 0 ? action.payload.Quiz[0] : {} : {},
                canView: true

            }
        case VideoActions.ACTION_USER_QUESTION_ADDED:
            return {
                ...state,
                videoQuestions: state.videoQuestions.concat(action.payload)
            };
        case VideoActions.ACTION_USER_QUESTION_UPDATED:
            return {
                ...state,
                videoQuestions: state.videoQuestions.map(v => {
                    if(v.id === action.payload.id){
                        return {...action.payload}
                    }else{
                        return {
                            ...v
                        }
                    }
                })
            };
        case VideoActions.UPDATED_NOTIFICATIONS:
            return {
                ...state,
                courseUser: state.courseUser.map(cu => {
                    if(cu.courseId === action.payload.notification.courseId){
                        return {
                            ...cu,
                            Course: {
                                ...cu.Course,
                                Notifications: cu.Course.Notifications.concat(action.payload.notification)
                            }
                        }
                    }else{
                        return cu
                    }
                })
            }
        case VideoActions.ACTION_POSTED_DISCUSSION:
            return {
                ...state,
                discussion: state.discussion.concat(action.payload)
            };
        case VideoActions.ACTION_CHAPTER_PART_RETRIEVED:
            return {
                ...state,
                chapterPart: {
                    ...action.payload,
                    VideoQuestions: action.payload.VideoQuestions.filter(q => (q.audioUrl !== null && q.answer !== "") || (q.correctOption !== "" && q.optionA !== ""))
                },
                discussion: action.payload.VideoDiscussion,
                loading: false,
                chapterPartTestResults: {},
                scoringTest: false,
                testScored: false
            };
        case VideoActions.ACTION_POSTED_DISCUSSION_COMMENT:
            return {
                ...state,
                discussion: state.discussion.map(d => {
                    if(d.id === action.payload.videoDiscussionId){
                        return {
                            ...d,
                            DiscussionComment: d.DiscussionComment.concat(action.payload)
                        }
                    }else{
                        return {
                            ...d
                        }
                    }
                })
            };
        case VideoActions.ACTION_LIKE_POSTED:
            return {
                ...state,
                discussion: state.discussion.map(d => {
                    if(d.id === action.payload.videoDiscussionId){
                        return {
                            ...d,
                            Like: d.Like.concat(action.payload)
                        }
                    }else{
                        return {
                            ...d
                        }
                    }
                })
            };
        case VideoActions.ACTION_LIKE_DELETED:
            return {
                ...state,
                discussion: state.discussion.map(d => {
                    if(d.id === action.payload.videoDiscussionId){
                        return {
                            ...d,
                            Like: d.Like.filter(l => l.id !== action.payload.id)
                        }
                    }else{
                        return {
                            ...d
                        }
                    }
                })
            }
        case VideoActions.ACTION_FOLLOW_POSTED:
            return {
                ...state,
                discussion: state.discussion.map(d => {
                    if(d.id === action.payload.videoDiscussionId){
                        return {
                            ...d,
                            Follow: d.Follow.concat(action.payload)
                        }
                    }else{
                        return {
                            ...d
                        }
                    }
                })
            };
        case VideoActions.ACTION_FOLLOW_DELETED:
            return {
                ...state,
                discussion: state.discussion.map(d => {
                    if(d.id === action.payload.videoDiscussionId){
                        return {
                            ...d,
                            Follow: d.Follow.filter(l => l.id !== action.payload.id)
                        }
                    }else{
                        return {
                            ...d
                        }
                    }
                })
            }
        case 'RESET_VIDEO_PROGRESS':
            return {
                ...state,
                uploadProgress: 0
            }
        case VideoActions.ACTION_LOAD_BLANK_VIDEO:
            return {...state, video: {}, uploadProgress: 0, loading: true};
        case VideoActions.ACTION_GET_VIDEO_DESCRIPTION:
            return {
                ...state,
                videoDescription: action.payload
            };
        case VideoActions.ACTION_UPLOAD_PROGRESS:
            return {
                ...state,
                uploadProgress: action.payload.progress,
                video: {}
            };
        case VideoActions.ACTION_VIDEO_FILE_RETRIEVED:
            return {
                ...state,
                uploadProgress: 0
            };
        case VideoActions.DEFAULT_STATE:
            return defaultState;
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/store/reducers/videoReducer.js